import { useContext, useState, useEffect } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Tooltip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import TextFieldErp from "../../../../components/basics/TextFieldErp";
import useClienteController from "../controllers/ClienteController";
import { ClienteContext } from "../contexts/ClienteContext";
import Card from "../../../../components/cards/Card";
import {
  HeaderAccordion,
  HeaderCard,
  IconButtonStyled,
  TableContent,
} from "../styles/Cliente";
import Chip from "../../../../components/basics/Chip";
import ModalClienteSocio from "./ModalClienteSocio";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { DeleteOutlined } from "@material-ui/icons";
import MaskService from "../../../../utils/mask/maskService";
import AddIcon from "@material-ui/icons/Add";
import TableDefault from "../../../../components/grid/TableDefault";

export default function AccordionClienteOutrasInfo() {
  const {
    otherBirthDate,
    setOtherBirthDate,
    otherAdditionalData,
    setOtherAdditionalData,
    otherCommercialReference,
    setOtherCommercialReference,
    otherNoteNfe,
    setOtherNoteNfe,
    otherPartners,
    setOtherPartners,

    expanded,
    errors,
  } = useContext(ClienteContext);
  const {
    handleChangeOpenAcordion,
    handleEditItemTable,
    handleRemoveItemTable,
  } = useClienteController();
  const [open, setOpen] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);
  const [dataTable, setDataTable] = useState([]);

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
    },
    {
      id: "nome",
      label: "Nome",
    },
    {
      id: "cpf",
      label: "CPF",
    },
  ];

  useEffect(() => {
    (async () => {
      const newList = [];
      otherPartners.forEach(
        (item, index) =>
          (newList[index] = {
            ...item,
            telefone: MaskService.toMask("cel-phone", item.telefone || ""),
            cep: MaskService.toMask("cep", item.cep || ""),
            acoes: (
              <SpeedDialErp
                actions={[
                  {
                    icon: <EditOutlinedIcon />,
                    name: "Editar",
                    action: () =>
                      handleEditItemTable(setOpen, setRowEdit, item, index),
                  },
                  {
                    icon: <DeleteOutlined />,
                    name: "Excluir",
                    action: () =>
                      handleRemoveItemTable(
                        setOtherPartners,
                        setDataTable,
                        otherPartners,
                        index
                      ),
                  },
                ]}
              />
            ),
          })
      );

      setDataTable(newList);
    })();
  }, [
    otherPartners,
    handleEditItemTable,
    handleRemoveItemTable,
    setOtherPartners,
  ]);

  return (
    <>
      {open && (
        <ModalClienteSocio
          open={open}
          setOpen={setOpen}
          rowEdit={rowEdit}
          setRowEdit={setRowEdit}
        />
      )}
      <Grid item xs={12}>
        <Accordion
          expanded={expanded.othersInfo || false}
          onChange={() => handleChangeOpenAcordion("othersInfo")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container>
                <Grid item xs={12}>
                  <Chip
                    label="OUTRAS INFORMAÇÕES (PESSOA JURÍDICA)"
                    bgcolor={
                      !expanded.othersInfo &&
                      errors.accordions &&
                      errors.accordions.includes("othersInfo")
                        ? "red"
                        : "default"
                    }
                    textcolor={
                      !expanded.othersInfo &&
                      errors.accordions &&
                      errors.accordions.includes("othersInfo")
                        ? "white"
                        : "default"
                    }
                  />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <Card line="left" lineColor="primary">
                  <HeaderCard style={{ marginBottom: "20px" }}>
                    <Grid container>
                      <Chip label="" bgcolor="secondary" />
                    </Grid>
                  </HeaderCard>

                  <Grid container spacing={2}>
                    <Grid item lg={4} md={6} sm={12} xs={12}>
                      <TextFieldErp
                        helperText={errors.otherBirthDate || ""}
                        error={errors.otherBirthDate ? true : false}
                        label="Data de Abertura"
                        value={otherBirthDate}
                        setValue={setOtherBirthDate}
                        type="date"
                      />
                    </Grid>

                    <Grid item lg={8} md={8} sm={12} xs={12}>
                      <TextFieldErp
                        label="Referência Comercial"
                        maxLength={255}
                        value={otherCommercialReference}
                        setValue={setOtherCommercialReference}
                      />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextFieldErp
                        label="Dados Adicionais"
                        maxLength={255}
                        value={otherAdditionalData}
                        setValue={setOtherAdditionalData}
                      />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextFieldErp
                        label="Observação para NF-e"
                        maxLength={255}
                        value={otherNoteNfe}
                        setValue={setOtherNoteNfe}
                      />
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item md={6} xs={12}>
                <Card line="left" lineColor="primary">
                  <HeaderCard>
                    <Grid
                      container
                      alignItems="center"
                      spacing={1}
                      style={{ marginBottom: 14 }}
                    >
                      <Grid item xs>
                        <Chip label="Dados dos Sócios" bgcolor="secondary" />
                      </Grid>
                      <Grid item flex={1}>
                        <Tooltip title="Adicionar Sócio">
                          <IconButtonStyled onClick={() => setOpen(true)}>
                            <AddIcon />
                          </IconButtonStyled>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </HeaderCard>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableContent>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TableDefault
                              columns={columns}
                              values={dataTable}
                              tableTitle=""
                              rowsPerPage={3}
                              maxHeight="33vh"
                              stickyHeader
                            />
                          </Grid>
                        </Grid>
                      </TableContent>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
